// Component validation levels mapping
export enum ComponentValidationLevel {
  NEVER_VALIDATED = 0, // No checkmark
  CONFIRMED = 1, // Green checkmark
  UNCONFIRMED_BUT_PLAUSIBLE = 2, // Yellow checkmark
  UNCONFIRMED_BUT_SUSPICIOUS = 3, // Orange checkmark
  CONFIRMATION_LEVEL_UNSPECIFIED = 4 // Red checkmark
}

// Component validation data structure
export interface ComponentValidation {
  street_number?: ComponentValidationLevel;
  route?: ComponentValidationLevel;
  subpremise?: ComponentValidationLevel;
  neighborhood?: ComponentValidationLevel;
  administrative_area_level_1?: ComponentValidationLevel;
  postal_code?: ComponentValidationLevel;
  country?: ComponentValidationLevel;
}

export interface Address {
  id: number;
  street1: string;
  street2?: string;
  unit?: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  verified: boolean;
  verified_components?: string | null; // JSON string with component validation levels
  inUseCount?: number; // Number of associations (properties, contacts, expenses)
  dateCreated: string;
  dateUpdated: string;
  whoUpdated: string;
}

// Address with component validation for form display
export interface AddressWithValidation extends Address {
  componentValidation?: ComponentValidation;
  hasInferredComponents?: boolean;
  inferredAddress?: Address;
}

export interface AddressFormData {
  street1: string;
  street2: string;
  unit: string;
  city: string;
  state: string;
  zip: string;
  country: string;
}

export interface CreateAddressRequest {
  street1: string;
  street2?: string;
  unit?: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  verified?: boolean;
  verified_components?: string | null; // JSON string with component validation levels
}

export interface UpdateAddressRequest {
  street1?: string;
  street2?: string;
  unit?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  verified?: boolean;
  verified_components?: string | null; // JSON string with component validation levels
}

export interface AddressSearchParams {
  search?: string;
  fields?: string[];
  page?: number;
  limit?: number;
  sorts?: Array<{
    field: 'street1' | 'city' | 'state' | 'zip' | 'dateCreated' | 'dateUpdated';
    direction: 'asc' | 'desc';
  }>;
  /** When true, exclude addresses already assigned to a property. */
  availableForProperty?: boolean;
  /** When availableForProperty is true, exclude addresses already linked to this property. */
  excludePropertyId?: number;
}

